export default __webpack_public_path__ + "static/media/twitter-m.7523a5fd.svg";